import api from 'js/api'
export const deleteAccount = (userid) =>
  api('DELETE', 'v2/accounts/account_delete', {
    userid,
  }).then((res) => res.response)
